























































import { Vue, Component } from "vue-property-decorator";
import { authService } from "../_services";
import * as auth from "../_store/auth.module";
import * as user from "../_store/user.module";
import { UserResetPassInfo } from "../_models/userResetPasswordInfo";
import { bus } from "../main"

@Component
export default class ValidationPage extends Vue {
  private token: string;
  private password: string;
  private confPassword: string;
  private passwordRules: [boolean | string];

  constructor() {
    super();
    this.token = "";
    this.password = "";
    this.confPassword = "";
    this.passwordRules = [true];
  }

  get pswMatchRules() {
    var rules: [boolean | string] = [false];
    if (this.password) {
      if (this.password === this.confPassword) {
        rules = [true];
      } else {
        rules = ["I valori delle password non combaciano"];
      }
    }
    return rules;
  }

  validazionePassword() {
    var valid: boolean = false;
    if (this.password !== "") {
      valid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{8,}$/.test(
        this.password
      );
    }
    if (valid) {
      this.passwordRules = [true];
    } else {
      this.passwordRules = [
        "La password deve essere lunga almeno 8 caratteri, contenere almeno un carattere speciale e un numero ed essere scritta con lettere maiuscole e minuscole"
      ];
    }
  }

  async executeTest() {
    this.validazionePassword();
  }

  onSubmit() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var payload ={
            token: this.token,
            password: this.password
        } 
        user.dispatchResetPassword(this["$store"], payload).then(() =>{
            bus.$emit("successfullOperation", "Password reimpostata correttamente");
        }).catch(error =>{
            bus.$emit("errorOperation", error.response.statusText);
        })
      }
    });
  }

  created() {
    auth.dispatchLogout(this["$store"]);
    var strArray: string[] = [];
    var urlArray: string[] = [];
    var urlString: string = window.location.href;
    urlArray = urlString.split("?");
    urlString = "https://valtis.infosys.it/#/resetPasswordPage?" + urlArray[1];
    strArray = urlArray[1].split("=");
    this.token = strArray[1];
  }
}
